export enum SortDirection {
  ASC = 0,
  DESC = 1,
}

export interface DynamicSort {
  field: string;
  direction: SortDirection;
  nestedField?: string;
}
